import { useEffect, useState } from "react";
import { useAccountsData } from "./useAccountsData";
export const useParsedAccountsData = (keys, parser) => {
    const data = useAccountsData(keys);
    const [parsed, setParsed] = useState(keys.map(() => undefined));
    useEffect(() => {
        setParsed((prevParsed) => {
            return data.map((datum, i) => {
                var _a;
                if (datum) {
                    if ((_a = prevParsed[i]) === null || _a === void 0 ? void 0 : _a.raw.equals(datum.accountInfo.data)) {
                        return prevParsed[i];
                    }
                    return Object.assign(Object.assign({}, datum), { accountInfo: Object.assign(Object.assign({}, datum.accountInfo), { data: parser(datum) }), raw: datum.accountInfo.data });
                }
                return datum;
            });
        });
    }, [data, parser]);
    return parsed;
};
//# sourceMappingURL=useParsedAccountsData.js.map